import React from "react";

export default function Navbar() {
  return (
    <nav className="navbar">
      <h1>Where in the World</h1>
    </nav>
  );
}
